import { business } from "../config/site.config";

const LOGO = `${process.env.PUBLIC_URL || ""}/brand`;

export const Logo = ({ dark = false }) =>
  dark ? (
    <a href="#top" className="block w-fit" data-testid="footer-logo-link" aria-label={`${business.name} — back to top`}>
      <img src={`${LOGO}/sab-logo-light.png`} alt={business.name} width="616" height="200" className="h-16 w-auto sm:h-[72px]" data-testid="footer-logo-image" />
    </a>
  ) : (
    <a href="#top" className="group flex items-center gap-3" data-testid="header-logo-link" aria-label={`${business.name} — back to top`}>
      <span className="flex flex-col leading-none">
        <img src={`${LOGO}/sab-logo-mark.png`} alt="SAB" width="358" height="96" className="h-8 w-auto self-start sm:h-9" data-testid="header-logo-image" />
        <span className="mt-1 font-mono text-[11px] uppercase tracking-[0.12em] text-charcoal-muted">Painting &amp; Decorating</span>
      </span>
    </a>
  );
